export const queryBuilder = function(searchObject, searchString) {
  var query = '';
  if (searchObject.language != '') {
    query += `language=${searchObject.language}&`;
  }
  if (searchObject.docType != 0) {
    query += `docType=${searchObject.docType}&`;
  }
  if (searchObject.productArea != 0) {
    query += `productArea=${searchObject.productArea}&`;
  }
  if (searchObject.brand.length > 0) {
    var brands = '';
    searchObject.brand.forEach(individualBrand => {
      brands += individualBrand + ',';
    });
    if (brands.length > 0) {
      brands = brands.substring(0, brands.length - 1);
    }
    if (brands != 0) {
      query += `brand=${brands}&`;
    }
  }
  if (searchString != '') {
    query += `search=${encodeURIComponent(searchString)}`;
  }
  if (query.charAt(query.length - 1) == '&') {
    query = query.substring(0, query.length - 1);
  }
  if (query == '') {
    return '/';
  }
  return '/?' + query;
};

export const parseQueryParams = function(queryParams, parse, searchString) {
  return new Promise(resolve => {
    if (queryParams.brand) {
      parse.brand = [];
      var split = queryParams.brand.split(',');
      split.forEach(individualBrand => {
        parse.brand.push(parseInt(individualBrand));
      });
    }
    parse.region = 1;
    if (queryParams.productArea) {
      parse.productArea = parseInt(queryParams.productArea);
    }
    if (queryParams.language) {
      parse.language = queryParams.language;
    }
    if (queryParams.docType) {
      parse.docType = parseInt(queryParams.docType);
    }
    if (queryParams.search) {
      searchString = queryParams.search;
    }
    resolve(searchString);
  });
};
